<app-page-breadcrumb pageTitle="Listas de Precios"></app-page-breadcrumb>

<div class="space-y-5">
  <div class="flex flex-wrap items-center justify-between gap-3">
    <p class="text-sm text-gray-500 dark:text-gray-400">
      Gestione listas de precios diferenciadas por cliente, moneda o canal
    </p>
    <div class="flex items-center gap-2">
      <button
        type="button"
        (click)="toggleFilters()"
        class="px-3 py-1.5 text-sm rounded-lg font-medium bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-600"
      >
        Filtros
      </button>
      <button
        type="button"
        (click)="nuevaLista()"
        class="px-3 py-1.5 text-sm rounded-lg font-medium bg-brand-500 text-white hover:bg-brand-600 flex items-center gap-1.5"
      >
        <svg
          class="w-4 h-4"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M12 4v16m8-8H4"
          ></path>
        </svg>
        Nueva Lista
      </button>
    </div>
  </div>

  @if (error) {
    <div
      class="p-4 bg-error-50 border border-error-200 rounded-lg dark:bg-error-500/10 dark:border-error-500/20"
    >
      <p class="text-sm text-error-600 dark:text-error-400">{{ error }}</p>
    </div>
  }

  @if (showFilters) {
    <div
      class="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-xl p-5"
    >
      <div class="grid grid-cols-1 sm:grid-cols-4 gap-3">
        <div>
          <label
            class="block text-xs font-medium text-gray-600 dark:text-gray-400 mb-1"
            >Nombre</label
          >
          <input
            type="text"
            [(ngModel)]="filterName"
            (ngModelChange)="buscar()"
            placeholder="Buscar"
            class="w-full px-3 py-2 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white"
          />
        </div>
        <div>
          <label
            class="block text-xs font-medium text-gray-600 dark:text-gray-400 mb-1"
            >predeterminada</label
          >
          <select
            [(ngModel)]="filterIsDefault"
            (ngModelChange)="buscar()"
            class="w-full px-3 py-2 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white"
          >
            <option [ngValue]="undefined">Todas</option>
            <option [ngValue]="true">Solo predeterminada</option>
            <option [ngValue]="false">Solo no predeterminada</option>
          </select>
        </div>
        <div>
          <label
            class="block text-xs font-medium text-gray-600 dark:text-gray-400 mb-1"
            >Moneda</label
          >
          <select
            [(ngModel)]="filterCurrencyId"
            (ngModelChange)="buscar()"
            class="w-full px-3 py-2 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white"
          >
            <option [ngValue]="undefined">Todas</option>
            @for (c of currencies; track c.id) {
              <option [ngValue]="c.id">{{ c.code }}</option>
            }
          </select>
        </div>
        <div>
          <label
            class="block text-xs font-medium text-gray-600 dark:text-gray-400 mb-1"
            >Estado</label
          >
          <select
            [(ngModel)]="filterIsActive"
            (ngModelChange)="buscar()"
            class="w-full px-3 py-2 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white"
          >
            <option [ngValue]="undefined">Todas</option>

            <option [ngValue]="true">Activos</option>
            <option [ngValue]="false">Inactivos</option>
          </select>
        </div>
        <div class="flex items-end">
          <button
            type="button"
            (click)="limpiarFiltro()"
            class="w-full px-3 py-2 text-sm rounded-lg font-medium bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-600"
          >
            Limpiar
          </button>
        </div>
      </div>
    </div>
  }

  <div
    class="overflow-hidden rounded-xl border border-gray-200 bg-white dark:border-gray-800 dark:bg-white/3"
  >
    @if (loading) {
      <div class="flex justify-center items-center py-10">
        <div
          class="animate-spin rounded-full h-6 w-6 border-b-2 border-brand-500"
        ></div>
        <span class="ml-3 text-gray-500 dark:text-gray-400 text-sm"
          >Cargando listas...</span
        >
      </div>
    } @else if (priceLists.length === 0) {
      <div class="text-center py-10 text-gray-500 dark:text-gray-400">
        <p class="text-sm">No hay listas de precios registradas.</p>
      </div>
    } @else {
      <div class="max-w-full overflow-x-auto">
        <table class="min-w-full">
          <thead class="border-b border-gray-100 dark:border-white/5">
            <tr>
              <th
                class="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400"
              >
                Nombre
              </th>
              <th
                class="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400"
              >
                Descripción
              </th>
              <th
                class="px-4 py-3 text-center text-xs font-medium text-gray-500 dark:text-gray-400"
              >
                Moneda
              </th>
              <th
                class="px-4 py-3 text-center text-xs font-medium text-gray-500 dark:text-gray-400"
              >
                Predeterminada
              </th>
              <th
                class="px-4 py-3 text-center text-xs font-medium text-gray-500 dark:text-gray-400"
              >
                Estado
              </th>
              <th
                class="px-4 py-3 text-right text-xs font-medium text-gray-500 dark:text-gray-400"
              >
                Productos
              </th>
              <th
                class="px-4 py-3 text-center text-xs font-medium text-gray-500 dark:text-gray-400"
              >
                Acciones
              </th>
            </tr>
          </thead>
          <tbody class="divide-y divide-gray-100 dark:divide-white/5">
            @for (list of priceLists; track list.id) {
              <tr>
                <td
                  class="px-4 py-3 text-sm font-medium text-gray-800 dark:text-gray-200"
                >
                  {{ list.name }}
                </td>
                <td class="px-4 py-3 text-xs text-gray-500 dark:text-gray-400">
                  {{ list.description || '-' }}
                </td>
                <td class="px-4 py-3 text-center">
                  <span
                    class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-mono bg-gray-100 text-gray-700 dark:bg-gray-700 dark:text-gray-300"
                  >
                    {{ getCurrencyCode(list.currencyId) }}
                  </span>
                </td>
                <td class="px-4 py-3 text-center">
                  @if (list.isDefault) {
                    <app-badge
                      color="primary"
                      size="sm"
                      >Predeterminada</app-badge
                    >
                  } @else {
                    <span class="text-xs text-gray-400">-</span>
                  }
                </td>
                <td class="px-4 py-3 text-center">
                  <app-badge
                    [color]="list.isActive ? 'success' : 'error'"
                    size="sm"
                  >
                    {{ list.isActive ? 'Activo' : 'Inactivo' }}
                  </app-badge>
                </td>
                <td
                  class="px-4 py-3 text-right text-xs text-gray-600 dark:text-gray-400"
                >
                  {{ list.totalItems ?? 0 }}
                </td>
                <td class="px-4 py-3">
                  <div class="flex items-center justify-center gap-1">
                    <button
                      type="button"
                      (click)="toggleActivo(list)"
                      [disabled]="togglingId === list.id || list.isDefault"
                      class="rounded p-1.5 hover:bg-gray-100 dark:hover:bg-gray-700 text-gray-400 disabled:opacity-30 disabled:cursor-not-allowed"
                      [class.hover:text-success-600]="!list.isActive"
                      [class.hover:text-error-600]="list.isActive"
                      [title]="
                        list.isDefault
                          ? 'La lista por defecto no se puede desactivar'
                          : list.isActive
                            ? 'Desactivar'
                            : 'Activar'
                      "
                    >
                      @if (list.isActive) {
                        <svg
                          class="w-4 h-4"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636"
                          ></path>
                        </svg>
                      } @else {
                        <svg
                          class="w-4 h-4"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M5 13l4 4L19 7"
                          ></path>
                        </svg>
                      }
                    </button>
                    <button
                      type="button"
                      (click)="verDetalle(list)"
                      class="rounded p-1.5 hover:bg-gray-100 dark:hover:bg-gray-700 text-gray-400 hover:text-gray-600"
                      title="Ver detalle"
                    >
                      <svg
                        class="w-4 h-4"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                        ></path>
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                        ></path>
                      </svg>
                    </button>
                    <button
                      type="button"
                      (click)="editarLista(list)"
                      class="rounded p-1.5 hover:bg-gray-100 dark:hover:bg-gray-700 text-gray-400 hover:text-gray-600"
                      title="Editar"
                    >
                      <svg
                        class="w-4 h-4"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                        ></path>
                      </svg>
                    </button>
                    <button
                      type="button"
                      (click)="eliminarLista(list)"
                      [disabled]="list.isDefault"
                      class="rounded p-1.5 hover:bg-error-50 hover:text-error-600 text-gray-400 disabled:opacity-30 disabled:cursor-not-allowed"
                      title="Eliminar"
                    >
                      <svg
                        class="w-4 h-4"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                        ></path>
                      </svg>
                    </button>
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
  </div>
</div>

<app-price-list-detail-modal
  [isOpen]="showDetailModal"
  [priceList]="selectedPriceList"
  [currencies]="currencies"
  (close)="cerrarModal()"
/>
